import createIcon from '../../createIcon';

/**
 * @component @name FastForward
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4yNSAxOEwxMS43NSAxMkwzLjI1IDZWMThaTTEyLjI1IDZWMThMMjAuNzUgMTJMMTIuMjUgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FastForward = createIcon('FastForward', [
  ['path', { d: 'M3.25 18L11.75 12L3.25 6V18ZM12.25 6V18L20.75 12L12.25 6Z', key: 'epip15' }],
]);

export default FastForward;
